import React from 'react'
import Banner from './Banner/Banner'
import Header from './Header/Header'
import LoginForm from './LoginForm/LoginForm'

function Login() {
  return (
      <div>
      <Banner></Banner>
      <Header></Header>
      <LoginForm></LoginForm>
      </div>
      
  )
}

export default Login